import { useEffect, useState } from "react";
import { useLoading } from "../../common/fetch/useLoading";
import { AreaDto } from "../../areas/area.interface";
import { getCaptureAreas } from "../services/collect-area.service";
import moment from "moment";

export function useCollectionAreaSearch() {
  const [areas, setAreas] = useState<AreaDto[]>([]);

  const { loading, setLoading, setDone } = useLoading();

  useEffect(() => {
    (async () => {
      try {
        setLoading();
        const result = await getCaptureAreas(moment().format("YYYYMMDD"));
        setAreas(result);
      } catch (e: any) {
        console.log(e);
      } finally {
        setDone();
      }
    })();
  }, []);

  return {
    areas,
    loading,
  };
}
